<template>
  <div>
    <v-progress-circular indeterminate v-if="loadingDevice"></v-progress-circular>
    <DisplayTable
      v-if="!loadingDevice"
      v-bind:data="device"
      v-bind:columns="deviceColumns"
      v-bind:routerLinkPath="'home'"
      v-bind:routerLinkKey="'homeId'"
      v-bind:tableTitle="'Device'"
    ></DisplayTable>

    <v-btn
      color="success"
      v-bind:disabled="togglingLight"
      v-on:click="toggleLight()"
    >Turn {{lightAction}} light</v-btn>

    <v-btn
      color="success"
      v-bind:disabled="loadingDeviceState"
      v-on:click="refreshDeviceState()"
    >Refresh State</v-btn>

    <br />
    <v-progress-circular indeterminate v-if="loadingUsers"></v-progress-circular>
    <DisplayTable
      v-if="!loadingUsers"
      v-bind:data="users"
      v-bind:columns="userColumns"
      v-bind:routerLinkPath="'user'"
      v-bind:routerLinkKey="'userId'"
      v-bind:tableTitle="'Users'"
    ></DisplayTable>
    <br />

    <v-progress-circular indeterminate v-if="loadingDeviceState"></v-progress-circular>

    <v-tabs
      v-model="tab"
      background-color="deep-purple accent-4"
      class="elevation-2"
      dark
      :centered="centered"
      :grow="grow"
      :vertical="vertical"
      :right="right"
      :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
      :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
      :icons-and-text="icons"
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab :key="'1'" :href="'#tab-deviceStateFriendly'">Device State</v-tab>

      <v-tab :key="'2'" :href="'#tab-deviceStateRaw'">Raw Data</v-tab>

      <v-tab-item :key="'1'" :value="'tab-deviceStateFriendly'">
        <v-card flat tile>
          <DisplayTable
            v-if="!loadingDeviceState"
            v-bind:data="deviceStateFriendly"
            v-bind:vertical="true"
            v-bind:tableTitle="'State'"
          ></DisplayTable>
        </v-card>
      </v-tab-item>

      <v-tab-item :key="'2'" :value="'tab-deviceStateRaw'">
        <v-card flat tile>
          <v-card-text>
            <DisplayTable
              v-if="!loadingDeviceState"
              v-bind:data="deviceState"
              v-bind:vertical="true"
              v-bind:tableTitle="'State'"
            ></DisplayTable>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>

    <br />
    <router-link :to="'/'">Go back to search page</router-link>
  </div>
</template>

<script>
var restHelper = require("../restHelper").default
var middleware = require("../middleware").default
import DisplayTable from "@/views/DisplayTable"

export default {
  components: {
    DisplayTable
  },
  data() {
    return {
      deviceId: "",
      device: [],
      deviceColumns: [],
      users: [],
      userColumns: [],
      loadingDevice: false,
      loadingUsers: false,
      loadingDeviceState: false,
      deviceState: [],
      deviceStateFriendly: [],
      togglingLight: false,
      lightState: false,
      lightAction: "on"
    }
  },
  async mounted() {
    middleware.run(this.$router)
    await this.init()
  },
  methods: {
    async init() {
      this.loadingDevice = true
      this.loadingUsers = true
      this.loadingDeviceState = true

      try {
        this.deviceId = this.$route.params.id
        var deviceResult = await restHelper.getDevice(this.deviceId)
        this.loadingDevice = false

        var homeId = deviceResult.data.homeId
        this.device = [deviceResult.data]
        this.deviceColumns = ["deviceId", "homeId", "alias"]

        var userResult = await restHelper.getUsersForHome(homeId)
        this.loadingUsers = false

        var deviceStateResult = await restHelper.getDeviceState(this.deviceId)
        this.loadingDeviceState = false
        this.deviceState = [deviceStateResult.data]
        this.deviceStateFriendly = [
          this.getFriendlyDeviceStateData(deviceStateResult.data)
        ]

        if ("lightState" in this.deviceState[0]) {
          this.lightState = this.deviceState[0].lightState
          if (this.lightState == 1) this.lightAction = "off"
        }

        this.users = userResult.data.users
        this.userColumns = [
          "userId",
          "email",
          "firstName",
          "lastName",
          "isAdmin"
        ]
      } catch (error) {}

      this.loadingDevice = false
      this.loadingUsers = false
      this.loadingDeviceState = false
    },

    async refreshDeviceState() {
      this.loadingDeviceState = true

      try {
        var deviceStateResult = await restHelper.getDeviceState(this.deviceId)
        this.deviceState = [deviceStateResult.data]

        this.deviceStateFriendly = [
          this.getFriendlyDeviceStateData(deviceStateResult.data)
        ]
      } catch (error) {}

      this.loadingDeviceState = false
    },

    async toggleLight() {
      this.togglingLight = true

      try {
        this.lightState = !this.lightState //toggle lightState and send command
        var commandBody = {
          command: "setLightState",
          lightState: this.lightState ? 1 : 0,
          requestId: Math.floor(Math.random() * 1000000000).toString()
        }
        var result = await restHelper.sendDeviceCommand(
          this.deviceId,
          commandBody
        )

        this.lightAction = this.lightState == 1 ? "off" : "on"
      } catch (error) {}

      this.togglingLight = false
    },

    getFriendlyDeviceStateData(deviceState) {
      //var friendlyDeviceState = Object.assign({}, deviceState)
      var friendlyDeviceState = []

      //show nicely formatted date in addition to unix timestamp
      var convertedDate = null
      if (
        deviceState["lastUpdatedTime"] &&
        deviceState["lastUpdatedTime"].toString().length <= 10
      ) {
        //if timestamp does not have milliseconds, multiple by 1000 (needed for devices that were not online since the recent ms backend change)
        convertedDate = new Date(
          parseInt(deviceState["lastUpdatedTime"]) * 1000
        ).toLocaleString()
      } else {
        convertedDate = new Date(
          parseInt(deviceState["lastUpdatedTime"])
        ).toLocaleString()
      }

      friendlyDeviceState["lastUpdatedTime"] = convertedDate

      friendlyDeviceState["lightColor"] =
        "background-color:#" + deviceState["lightColor"]

      friendlyDeviceState["defaultSlot"] = this.getSlotName(
        deviceState["defaultSlot"]
      )
      friendlyDeviceState["continuousSlot"] = this.getSlotName(
        deviceState["continuousSlot"]
      )
      friendlyDeviceState["slot"] = this.getSlotName(deviceState["slot"])
      friendlyDeviceState["intensity1"] = this.getIntensityName(
        deviceState["intensity1"]
      )
      friendlyDeviceState["intensity2"] = this.getIntensityName(
        deviceState["intensity2"]
      )
      friendlyDeviceState["mode"] = this.getModeName(deviceState["mode"])

      friendlyDeviceState["lightState"] = this.getLightStateName(
        deviceState["lightState"]
      )

      friendlyDeviceState["lidState"] = this.getLidStateName(
        deviceState["lidState"]
      )

      return friendlyDeviceState
    },

    getSlotName(slotNum) {
      return slotNum == 2 ? "right" : "left"
    },

    getIntensityName(intensity) {
      var intensityName = null
      switch (intensity) {
        case 1:
          intensityName = "low"
          break
        case 2:
          intensityName = "medium"
          break
        case 3:
          intensityName = "high"
          break
      }

      return intensityName
    },

    getModeName(mode) {
      var modeName = null
      switch (mode) {
        case 0:
          modeName = "standby"
          break
        case 1:
          modeName = "schedule"
          break
        case 2:
          modeName = "continuous"
          break
        case 3:
          modeName = "burst"
          break
      }

      return modeName
    },

    getLightStateName(lightState) {
      return lightState == 1 ? "on" : "off"
    },

    getLidStateName(lidState) {
      return lidState == 0 ? "closed" : "open"
    }
  }
}
</script>

